import React from 'react'

const ButtonFunc = (props) => {
  return (
    <button className={`text-base py-3 ${props.color} ${props.textColor} ${props.rounded && 'rounded'} border border-[#b3853e]`} onClick={props.function}>{props.name}</button>
  )
}

export default ButtonFunc